import type { EvaluationContext, EvaluationContextValue } from "@openfeature/core";

export type FeatureFlagContextInput = {
  userId?: string | null;
  orgId?: string | null;
  orgRole?: string | null;
  email?: string | null;
  targetingKey?: string | null;
  attributes?: Record<string, unknown>;
};

export type FeatureFlagContext = EvaluationContext & {
  targetingKey: string;
};

function readString(value: string | null | undefined) {
  return typeof value === "string" && value.trim().length > 0 ? value.trim() : null;
}

function isFlatContextValue(value: unknown): value is EvaluationContextValue {
  return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
}

function setFlatValue(target: EvaluationContext, key: string, value: unknown) {
  if (isFlatContextValue(value)) target[key] = value;
}

export function buildFeatureFlagContext(input: FeatureFlagContextInput = {}): FeatureFlagContext {
  const userId = readString(input.userId);
  const orgId = readString(input.orgId);
  const orgRole = readString(input.orgRole);
  const email = readString(input.email);
  const targetingKey = readString(input.targetingKey) || userId || (orgId ? `org:${orgId}` : "anonymous");
  const context: FeatureFlagContext = { targetingKey };

  if (userId) {
    context.user_id = userId;
    context.clerk_user_id = userId;
  }
  if (orgId) {
    context.org_id = orgId;
    context.clerk_org_id = orgId;
  }
  if (orgRole) context.org_role = orgRole;
  if (email) context.email = email;

  for (const [key, value] of Object.entries(input.attributes ?? {})) {
    if (key !== "targetingKey") setFlatValue(context, key, value);
  }

  return context;
}

export function featureFlagContextKey(context: EvaluationContext | null | undefined) {
  if (!context) return "none";
  return JSON.stringify(Object.entries(context).sort(([left], [right]) => left.localeCompare(right)));
}
